/* eslint-disable */ 

import React, { useState, useEffect, useRef } from "react"
// import elasticlunr from "elasticlunr"
import * as JsSearch from 'js-search';
import { Link } from "gatsby"

import { useStaticQuery, graphql, withPrefix } from "gatsby"
//import frontmatter from "front-matter"

import Modal from "./Modal"

import {
    searchTab as searchTabStyle,
    active as activeStyle,
    tabs as tabsStyle,
    results as resultsStyle,
    resultItem as resultItemStyle,
    resultItemHeader as resultItemHeaderStyle,
    resultItemHeaderParams as resultItemHeaderParamsStyle,
    paramName as paramNameStyle,
    paramMethod as paramMethodStyle,
    pageSectionName as pageSectionNameStyle,
    sectionDetails as sectionDetailsStyle,
    httpMethod as httpMethodStyle,
    paramDetails as paramDetailsStyle,
    paramDataType as paramDataTypeStyle,
    paramReq as paramReqStyle,
    paramOpt as paramOptStyle,
    resultItemBody as resultItemBodyStyle,
    container as containerStyle,
    searchBtn as searchBtnStyle,
    header as headerStyle,
    resultsCounter as resultsCounterStyle,
    sectionIcon,
    breadcrumbs as breadcrumbsStyle,
    method as methodStyle,
    sectionIconInResult,
    resultContentContainer
} from "./search.module.css"

export default function Search({jsonDataSource}) {

    // replacing rawBody with body

    // const siteMdxData = useStaticQuery(graphql`
    //     query {         
    //         allMdx {
    //             nodes {
    //               fields {
    //                 slug
    //               }
    //               body
    //               frontmatter {
    //                 post_title
    //                 redirect
    //               }
    //             }
    //         }                       
    //     }
    // `)    

    const allData = useStaticQuery(graphql`
        query {         
            allMdx {
                nodes {
                  fields {
                    slug
                  }
                  body
                  frontmatter {
                    post_title
                    redirect
                    dir
                  }
                }
            }    
            allApiJson{
                edges {
                  node {
                    name
                    content {
                      title
                      menu_title
                      method
                      version
                      name
                      description
                      message{
                          type
                          text
                      }
                      request_description
                      code {
                        name
                        example
                      }
                      method_arguments{
                        order
                        name
                        data_type
                        short_description
                        required
                        description                          
                      }          
                      return_object{
                          name
                          order
                          description
                          short_description
                      }                                
                      response
                      response_description
                      input_objects{
                          name
                          description
                          short_description                          
                          attributes{
                            name
                            short_description
                            order
                            data_type
                            required
                            description                         
                            attributes{
                                name
                                order
                                required
                                data_type
                                short_description
                                description
                                message{
                                    type
                                    text
                                }                                  
                                attributes{
                                    name
                                    order
                                    required
                                    data_type
                                    short_description
                                    description                                 
                                    attributes{
                                        name
                                        order
                                        required
                                        data_type
                                        short_description
                                        description                                        
                                    }                                         
                                }                                  
                            }                              
                          }
                      }
                      output_objects{
                          name
                          description
                          data_type                       
                          short_description
                          example                           
                          attributes{
                            name
                            order
                            data_type
                            short_description
                            description                                
                            attributes{
                                name
                                order
                                data_type
                                short_description
                                description    
                                attributes{
                                    name
                                    required
                                    data_type
                                    short_description
                                    description    
                                    attributes{
                                        name
                                        order
                                        required
                                        data_type
                                        short_description
                                        description                                                                     
                                    }                                                                                                        
                                }                                                                                                    
                            }                               
                          }
                      }                     
                    }
                  }
                }
              }                      
        }
    `)        


    const [query, setQuery] = useState('')
    const [results, setResults] = useState([])

    const [showModal, setShowModal] = useState(false)

    // break slug into list of urls
    // '/tutorials/content-delivery/custom-domains/#introduction'
    // ['/tutorials/', '/tutorials/content-delivery/', '/tutorials/content-delivery/custom-domains/']
    function getPathSegments(slug) {
        // Remove the hash part and any trailing slashes
        const cleanSlug = slug.replace(/#.*/, '').replace(/\/+$/, '');
      
        // Split the slug into segments after removing the first empty segment from leading slash
        const segments = cleanSlug.split('/').slice(1);
      
        // Create an array to hold the paths
        const paths = [];
      
        // Use reduce to build up the paths array
        segments.reduce((accumulator, currentSegment) => {
          // Construct the path by appending the current segment to the accumulator
          const path = `${accumulator}/${currentSegment}`;
          paths.push(path);
          return path;
        }, '');
      
        // Add a trailing slash to each path
        return paths.map(path => `${path}/`);
    }       

    // convert list into breadcrumbs
    // ['/tutorials/', '/tutorials/content-delivery/', '/tutorials/content-delivery/custom-domains/']
    // Tutorials > CDN > Custom Domains
    function getBreadcrumbsString (url) {

        let result = ''

        const slugsList = getPathSegments(url)

        slugsList.forEach( (slug, index) => {
            // console.log(allData.allMdx.nodes[0])
            const letFoundNode = allData.allMdx.nodes.filter( (node) => node.fields.slug === slug)[0] 
            if(letFoundNode){
                // result += letFoundNode.frontmatter.post_title
                result += letFoundNode.frontmatter.dir
                // if not the last one, add ' > '
                if(index < slugsList.length - 1){
                    result += ' > '
                }
            }
        });

        
        return result
    }

    // flatten the Tree for search index
    // 1st we add only info for Transcoding
    let jsonDataArray  = []

    // there can be different JSON data sources, now we only filter for transcoding
    // because each data source may have its own data structure
    // and data for seach index must be prepared based on that

    // SEARCH SECTIONS
    // api-reference   API Reference
    // tutorials       Tutorials
    // faq             FAQ
    // support         don't add to search index

    const indexData = [
        {
            nodeName: 'transcoding',
            transcodingPrefix: '/api-reference/transcoding/',
            transcodingIndexIdPrefix: 'transcoding_section_'            
        },

        {
            nodeName: 'streaming',
            transcodingPrefix: '/api-reference/streaming/',
            transcodingIndexIdPrefix: 'streaming_section_'            
        },
        
        {
            nodeName: 'cdn',
            transcodingPrefix: '/api-reference/cdn/',
            transcodingIndexIdPrefix: 'cdn_section_'            
        }           

    ]


    let prefix = null

    let contentJSON 

    let nodeJSON 

    jsonDataSource = allData.allApiJson
    
    if(jsonDataSource){

        indexData.forEach(({nodeName, transcodingPrefix, transcodingIndexIdPrefix}) => {

            prefix = transcodingPrefix
            nodeJSON = jsonDataSource.edges.filter( ({node}) => node.name === nodeName)[0] 
            contentJSON = nodeJSON.node.content

            contentJSON.forEach(({ title, menu_title, description, name, method, version, method_arguments, return_object, input_objects, output_objects }, sectionIndex) => {

                const http_method = method
                const api_method = `/${version}/${name}`

                const jsonSlug = `${prefix}#${title.toLowerCase().split(' ').join('-')}`
    
                jsonDataArray.push({
                    id: `${transcodingIndexIdPrefix}${sectionIndex}`,
                    title: title,
                    slug: jsonSlug,
                    content: description.replace(/<[^>]+>/g, ''),              
                    prefix: prefix,
                    type: "section",
                    http_method: http_method,
                    method:api_method,
                    var_type:'',
                    required:'',
                    section: 'API Reference',
                    extradata:"001_hello",
                    breadcrumbs: getBreadcrumbsString(jsonSlug) + " > " + menu_title   
                })
             
    
                let methodName = name

                // remove /<>
                if(methodName){
                    //console.log("methodName in search: ", methodName)
                    let formatedMethodName = methodName.replace(/[^0-9a-zA-Z_-]/g, "")
                    //console.log("formatedMethodName search: ", formatedMethodName)
                    methodName = formatedMethodName
                }                  
    
                const flattenTree = (data, parent, tableName) => {
                    data.forEach(({name, data_type, required, attributes, description}) => {

                        // name //todo: rename
                        // http://localhost:8000/api-reference/streaming/#live-streamsstream_idstoptodorename___timestamp__returns

            
                        let formatedName = ''
                        if(name){
                            formatedName = name.toLowerCase().replace(/\s/g, '-').replace(/[^0-9a-zA-Z_-]/g, "")
                        }  

                        //console.log("name: ", name);
                        
                        // we add methodName one time only
                        //const id = parent ? `${parent}--${name.toLowerCase().replace(/\s/g, '-')}__${tableName}` : `${methodName}___${name.toLowerCase().replace(/\s/g, '-')}__${tableName}`                    
                        const id = parent ? `${parent}--${formatedName}__${tableName}` : `${methodName}___${formatedName}__${tableName}`          

                        if(attributes){
                            flattenTree(attributes, id, tableName)
                        }
    
                        let content = ''
                        if(description){
                            content = description.replace(/<[^>]+>/g, '') 
                        }

                        const methodSlug = `${prefix}#${id}`
                        
                        jsonDataArray.push({
                            id: `${id}`,
                            title: name,
                            slug: methodSlug,
                            content: content,
                            prefix: prefix,
                            type: "parameter",
                            http_method: http_method,
                            method:api_method,
                            var_type: data_type,
                            required: required ? "req" : "opt",
                            section: 'API Reference',      
                            extradata:"002_hello",
                            breadcrumbs: getBreadcrumbsString(methodSlug)                              
                        })
    
    
                    })
                }
    
                if(method_arguments){
                    flattenTree(method_arguments, null, 'arguments')
                }  
    
                if(return_object){
                    flattenTree(return_object, null, 'returns')
                }                                
    
                if(input_objects){
                    flattenTree(input_objects, null, 'attributes')
                }
    
                if(output_objects){
                    flattenTree(output_objects, null, 'attributes')
                }                
        
            })              
        })
        
    }    



    // add pages data to sarch index
    let siteNodes = allData.allMdx.nodes

    siteNodes.forEach( (node, index) => {

        // var anchorTagsRemoved = myString.replace(/<a.*>.*?<\/a>/ig,'');
       
        //const mdxRawBodyWithoutH1 = node.rawBody.replace(/<h1.*>.*?<\/h1>/ig,'');
        const mdxRawBodyWithoutH1 = node.body.replace(/<h1.*>.*?<\/h1>/ig,'');
        
        //const mdxRawBody = node.rawBody.replace(/<[^>]+>/g, '') // remove all tags 
        const mdxRawBody = mdxRawBodyWithoutH1.replace(/<[^>]+>/g, '') // remove all tags 
        //const { body } = frontmatter(mdxRawBody) 
        // let pageContent = body
        let pageContent = mdxRawBody
    
        // SEARCH SECTIONS
        // api-reference   API Reference
        // tutorials       Tutorials
        // faq             FAQ
        // support         don't add to search index        

        // analyze node.fields.slug 

        let sectionName = ''             

        if(node.fields.slug.startsWith('/api-reference')){
            sectionName = 'API Reference'
        }  
        
        if(node.fields.slug.startsWith('/tutorials')){
            sectionName = 'Tutorials'
        } 

        if(node.fields.slug.startsWith('/release')){
            sectionName = 'Release Notes'            
        } 

        if(node.fields.slug.startsWith('/faq')){
            sectionName = 'FAQ'
        }  
        
        if(node.fields.slug.startsWith('/support')){
            sectionName = 'Support'
        }          

        // console.log("sectionName: ", sectionName)
        
        // if frontmatter has redirect we ignore this page and do not include it into search index
        let ignore = node.frontmatter.redirect ? true : false

        // ignore Home page
        if(node.fields.slug === '/'){
            ignore = true
        }

        if(!ignore){
            jsonDataArray.push({
                id: `page_${index}`,
                title: node.frontmatter.post_title,
                // slug: "/"+node.fields.slug+"/",
                // slug: "/"+node.fields.slug,
                slug: node.fields.slug,
                //content: pageContent, 
                content: pageContent.substring(0, 100),  
                prefix: '',
                type: "page",
                http_method:'',
                method:'',
                var_type:'',
                required:'',
                section: sectionName,
                extradata:"003_hello",
                breadcrumbs: getBreadcrumbsString(node.fields.slug)              
            })     

            // console.log("jsonDataArray: ", jsonDataArray)

            // look for h2 tags with IDs in node.rawBody       
            // ## Receive Callbacks     
            // <h2 id="receive-callbacks" style="position: relative;">Receive Callbacks</h2>

            // ## 4. Define Output Settings 
            // <h2 id="4-define-output-settings" style="position: relative;">4. Define Output Settings</h2>

            //if(node.fields.slug === 'api-reference/transcoding'){
            if(node.fields.slug){
                //console.log("node.fields.slug: ", node.fields.slug)
                //console.log("node.rawBody: ", node.rawBody)

                let pageSections = []

                // let rawMarkDown = node.rawBody
                let rawMarkDown = node.body
                let lines = rawMarkDown.split('\n');

                let titles = lines.filter(line => line.startsWith('## ')).reverse()
                //console.log("titles: ", titles)

                // 1. we find last title in the page and copy everything starting from it to the end to new section
                // 2. after that we remove title and everything below it from the text and repeat step 1

                titles.forEach(title => {

                    let titleIndex = rawMarkDown.indexOf(title)                    
                    let section = rawMarkDown.substring(titleIndex, rawMarkDown.length)

                    let sectionContent = section.substring(title.length, section.length).replace(/<[^>]+>/g, '') // remove all tags 
                    let sectionTitle = title.substring(3, title.length);
                   
                    pageSections.push({
                        id: sectionTitle.toLowerCase().split(' ').join('-').replace(/\./g,''), // id must match id generated for h2 tag, remove all dots
                        title: sectionTitle,
                        content: sectionContent
                    })
                    
                    rawMarkDown = rawMarkDown.substring(0, titleIndex);
                })

                pageSections.reverse()

                //console.log("pageSections: ", pageSections)
                // http://localhost:8000/api-reference/transcoding#error-codes
                // "/tutorials/transcoding/getting-started/launch-a-job/#6.-checking-status"
                //<h2 id="6-checking-status" style="position: relative;">6. Checking Status</h2>

                pageSections.forEach(({title, id, content}, sectionIndex) => {
                    //console.log("title: ", title)
                    jsonDataArray.push({
                        id: `page_section_${index}_${sectionIndex}`,
                        title: title,
                        // slug: "/"+node.fields.slug+'/'+"#"+ id,
                        slug: node.fields.slug + "#" + id,
                        content: content,  
                        prefix: '',
                        type: "page",
                        http_method:'',
                        method:'',
                        var_type:'',
                        required:'',
                        section: sectionName,
                        extradata:"004_hello",
                        //breadcrumbs: `${sectionName} > ${title}`  
                        breadcrumbs: getBreadcrumbsString(node.fields.slug)        
                    })                       
                })

                
                                  
            }
        }           

    })

    //console.log("jsonDataArray: ", jsonDataArray)


    const dataToSearch = new JsSearch.Search("id")
    //dataToSearch.indexStrategy = new JsSearch.PrefixIndexStrategy()
    //dataToSearch.indexStrategy = new JsSearch.ExactWordIndexStrategy()
    dataToSearch.indexStrategy = new JsSearch.AllSubstringsIndexStrategy()
    dataToSearch.sanitizer = new JsSearch.LowerCaseSanitizer()
    dataToSearch.searchIndex = new JsSearch.TfIdfSearchIndex("id")

    dataToSearch.addIndex('title')

    dataToSearch.addIndex('content')

    dataToSearch.addIndex('method')

    dataToSearch.addIndex('section')

    dataToSearch.addDocuments(jsonDataArray)         

    //console.log("jsonDataArray: ", jsonDataArray);

    const search = (query) => {
        setQuery(query)  

        let queryResult = dataToSearch.search(query)   
        

        let queryWorsList = query.split(' ');

        queryResult =  queryResult.filter(({title, content, method, section }) => {   

            let found = false;

            queryWorsList.forEach(queryWord => {

                if(!title){
                    title='reference'
                    //TODO see reference in index
                }

                if(title.toLowerCase().includes(queryWord.toLowerCase())){
                    found = true;
                }                    
              

                
                if(content.toLowerCase().includes(queryWord.toLowerCase())){
                    found = true;
                }                  

                if(method.toLowerCase().includes(queryWord.toLowerCase())){
                    found = true;
                }     
                
                if(section.toLowerCase().includes(queryWord.toLowerCase())){
                    found = true;
                }                   

            })

            return found;
            
        });

        // console.log("queryResult: ", queryResult)

        setResults(queryResult)        
    }    

    const searchInput = useRef(null)

    useEffect(() => {

     if(showModal){
        searchInput.current.focus()
     }
    
    }, [showModal])      

    // SEARCH SECTIONS
    // api-reference   API Reference
    // tutorials       Tutorials
    // faq             FAQ
    // support         don't add to search index        


    

    const SearchTabsBar = ({results}) => {

        let filteredResults = results

        // src={withPrefix(`/images/docs/${item.dir}.svg`)}

        const tabsInitialState = [
            {
                name: 'All',
                selected: true,
                numberOfResults: 0,
                iconUrl: withPrefix(`/images/icons/search.svg`)
            },   
            {
                name: 'API Reference',
                selected: false,
                numberOfResults: 0,
                iconUrl: withPrefix(`/images/docs/api-reference.svg`)
            },
            {
                name: 'Tutorials',
                selected: false,
                numberOfResults: 0,
                iconUrl: withPrefix(`/images/docs/tutorials.svg`)
            },
            {
                name: 'Release Notes',
                selected: false,
                numberOfResults: 0,
                iconUrl: withPrefix(`/images/docs/release.svg`)
            },
            // {
            //     name: 'FAQ',
            //     selected: false,
            //     numberOfResults: 0
            // },
            // {
            //     name: 'All',
            //     selected: false,
            //     numberOfResults: 0
            // }                        
        ]
        const [tabs, setTabs] = useState(tabsInitialState)           

        const updateSelectedTab = (index) => {
            let newTabsStates = [...tabs]
            newTabsStates.map(tab => {
                return tab.selected = false
            })
            newTabsStates[index].selected = true
            setTabs(newTabsStates)          

        }

        useEffect(() => {

            let apiReferencesResults = results.filter( item => item.section === "API Reference")
            let tutorialsResults = results.filter( item => item.section === "Tutorials")
            let releaseResults = results.filter( item => item.section === "Release Notes")
            let faqResults = results.filter( item => item.section === "FAQ")


            // console.log("results: ", results)
            // console.log("apiReferencesResults: ", apiReferencesResults)
            // console.log("tutorialsResults: ", tutorialsResults)

            let newTabsStates = [...tabs]

            // set all number of results
            newTabsStates.map(tab => {
                if(tab.name === "All"){
                    tab.numberOfResults = results.length
                }

                if(tab.name === "API Reference"){                
                    tab.numberOfResults = apiReferencesResults.length
                }  

                if(tab.name === "Tutorials"){                
                    tab.numberOfResults = tutorialsResults.length
                }   

                if(tab.name === "Release Notes"){                
                    tab.numberOfResults = releaseResults.length
                }   
                
                if(tab.name === "FAQ"){                
                    tab.numberOfResults = faqResults.length
                }                   
                               
                return tab
            })


            setTabs(newTabsStates) 
    
        }, [results])        

        useEffect(() => {
            // console.log("UPDATE RESULTS")

            // find name of selected tab and filter results filteredResults
            let selectedTabName = tabs.filter( tab => tab.selected === true)[0].name
                     
            if(selectedTabName === "All"){
                filteredResults = results
            } else{
                filteredResults = results.filter(item => item.section === selectedTabName)
            }



        }, [tabs])

        // find name of selected tab and filter results filteredResults
        let selectedTabName = tabs.filter( tab => tab.selected === true)[0].name         
    
        if(selectedTabName === "All"){
            filteredResults = results
        } else{
            filteredResults = results.filter(item => item.section === selectedTabName)
        }      
        
        const tabsElements = tabs.map( ({name, selected, numberOfResults, iconUrl}, index) => {
            return (
                <div 
                    key={index}
                    className = {
                        selected 
                        ? `${searchTabStyle} ${activeStyle}`
                        : searchTabStyle
                    }                    
                    onClick={() => updateSelectedTab(index)}  onKeyDown={() => updateSelectedTab(index)} 
                    role="button" tabIndex="0"                                     
                >
                    {/* {name} ({numberOfResults}) */}
                    <img className={sectionIcon} src={iconUrl} alt={name} />
                    <div>{name}</div>
                </div>
            )
        })        


        const sectionIconResult = (slug) => {
            let imageSrc = ''

            if(slug.startsWith('/api-reference')){
                imageSrc = withPrefix(`/images/docs/api-reference.svg`)
            }

            if(slug.startsWith('/tutorials')){
                imageSrc = withPrefix(`/images/docs/tutorials.svg`)
            }

            if(slug.startsWith('/release')){
                imageSrc = withPrefix(`/images/docs/release.svg`)
            }

            return imageSrc
        }


        return (
            <div>

                <div className={tabsStyle}>
                    {tabsElements}
                </div>

                <div className={resultsStyle}>
                { 
                    filteredResults.length > 0 && 
                        <ul>
                            {filteredResults.map(item => (
                                <li key={item.id}>                      
                                    <Link to={item.slug} onClick={() => setShowModal(false)}>                                    
                                        <div className={resultItemStyle}>
                                            <img className={sectionIconInResult} src={sectionIconResult(item.slug)} alt="" />
                                            <div className={resultContentContainer}>
                                                <div className={resultItemHeaderStyle}>
                                                    
                                                    <div className={resultItemHeaderParamsStyle}>                                                    
                                                        {
                                                            item.type === "parameter" 
                                                            ?
                                                            <>
                                                                <span className={paramNameStyle}>{item.title}</span>
                                                                {/* <span className={paramMethodStyle}>{item.method}</span> */}
                                                            </>
                                                            : <>{item.title}</>
                                                        }
                                                    </div>

                                                    {/* {
                                                        item.type === "page" && 
                                                        <div className={pageSectionNameStyle}>
                                                            {item.section}
                                                        </div>
                                                    } */}
                                        
                                                    {
                                                        item.type === "section" &&
                                                        <div className={sectionDetailsStyle}>
                                                            <div className={methodStyle}>{item.method}</div>
                                                            <div className={httpMethodStyle}>{item.http_method}</div>                                                        
                                                        </div>
                                                    } 

                                                    {
                                                        item.type === "parameter" &&
                                                        <div className={paramDetailsStyle}>
                                                            <div className={paramDataTypeStyle}>{item.var_type}</div>    
                                                            {
                                                                item.required === "req" &&
                                                                <div className={paramReqStyle}>{item.required}</div>                                                               
                                                            } 
                                                            {
                                                                item.required === "opt" &&
                                                                <div className={paramOptStyle}>{item.required}</div>                                                               
                                                            }                                                                             
                                                        </div>
                                                    }                                                             
                                                </div>                                            
                                                {/* {
                                                    item.content &&
                                                    <div className={resultItemBodyStyle}>
                                                        {item.content}
                                                    </div>
                                                } */}
                                                {
                                                    item.breadcrumbs &&
                                                    <div className={breadcrumbsStyle}>
                                                        {item.breadcrumbs}
                                                    </div>
                                                }                                            
                                                {/* {
                                                    item.slug &&
                                                    <div className="">
                                                        {breadCrumbs(item.slug)}
                                                    </div>
                                                }                                             */}                                                
                                            </div>
                                        </div>
                                    </Link>

                                </li>
                            ))}
                        </ul>
                }  
                </div>

            </div>            
        )
    }

    // add/remove keydown event handler to the document
    useEffect(() => {
        const keyDownHandleSearch = (e) => {
            if(e.ctrlKey && e.code === "KeyF"){
                e.preventDefault()
                setShowModal(true)
            }

            if(e.code === "Escape"){
                e.preventDefault()
                setShowModal(false)
            }             
           
        }

        document.addEventListener("keydown", keyDownHandleSearch)

        // these functions clean up the event listeners
        return () => document.removeEventListener("keydown", keyDownHandleSearch)
    })      
    
    return(       
        <div className={containerStyle}>

            <button className={searchBtnStyle} id="search_btn" onClick={() => setShowModal(true)}>
                Search...
            </button>            
                    
            <Modal id="search" show={showModal} handleClose={() => setShowModal(false)}>

                <div className={headerStyle}>
                    <input type="text" ref={searchInput} placeholder="Search..." value={query} onChange={e => search(e.target.value)} />
                    {/* <div className={resultsCounterStyle}>{results.length} Results</div> */}
                </div>

                <SearchTabsBar results={results} />

            </Modal>            

          
        </div>
    )
}

